<template>
  <b-card
    no-body
    :name="id + '_card'"
    :class="[
      maintnance == true || update == true
        ? 'mb-2 link-card'
        : 'mb-2 link-card shrink',
    ]"
    tabindex="1"
    @click="openInNewTab(link)"
    v-on:keyup.enter="openInNewTab(link)"
    v-on:keyup.space="openInNewTab(link)"
  >
    <div style="display: flex; width: 100%;">
      <div>
        <b-card-img
          :src="thumbnail"
          alt="Image"
          class="rounded-0"
          style="min-width: 180px"
        ></b-card-img>
      </div>
      <div style="width: 100%">
        <b-card-body :title="title">
          <b-card-text>{{ description }}</b-card-text>
          <b-card-text class="coming-soon" v-if="update == true"
            >Coming soon</b-card-text
          >
          <b-card-text class="coming-soon" v-if="maintnance == true"
            >To be developed</b-card-text
          >
          <b-card-text class="coming-soon" v-if="prototype == true"
            >Prototype for testing</b-card-text
          >
        </b-card-body>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "link-card",
  props: {
    id: Number,
    title: String,
    thumbnail: String,
    description: String,
    link: String,
    maintnance: Boolean,
    update: Boolean,
    prototype: Boolean,
  },
  methods: {
    openInNewTab(url) {
      if (url !== "") {
        var win = window.open(url);
        win.focus();
      }
    },
  },
};
</script>

<style scoped>
.coming-soon {
  font-style: italic;
}
</style>
